<div [class]="className()">
  <img [src]="urlLoaderImg | safe: 'url'" />
</div>
